import React, { useState } from 'react';
import './NewCommentForm.scss';

interface Props {
  postId: number;
  addComment: (newComment: Partial<Comment>) => void;
}

export const NewCommentForm: React.FC<Props> = (props) => {
  const { postId, addComment } = props;

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [body, setBody] = useState('');

  const setDefaultValues = () => {
    setName('');
    setEmail('');
    setBody('');
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const newComment = {
      name,
      email,
      body,
      postId,
    };

    addComment(newComment);
    setDefaultValues();
  };

  return (
    <form
      className="NewCommentForm"
      onSubmit={handleSubmit}
    >
      <div className="form-field">
        <input
          type="text"
          name="name"
          placeholder="Your name"
          className="NewCommentForm__input"
          value={name}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setName(event.target.value);
          }}
        />
      </div>

      <div className="form-field">
        <input
          type="text"
          name="email"
          placeholder="Your email"
          className="NewCommentForm__input"
          value={email}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setEmail(event.target.value);
          }}
        />
      </div>

      <div className="form-field">
        <textarea
          name="body"
          placeholder="Type comment here"
          className="NewCommentForm__input"
          value={body}
          onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
            setBody(event.target.value);
          }}
        />
      </div>

      <button
        type="submit"
        className="NewCommentForm__submit-button button"
      >
        Add a comment
      </button>
    </form>
  );
};
